module.exports = __webpack_public_path__ + "img/video.e1f1db4f.svg";